import ApiService from '../../components/api_services/apiService.jsx';
import ActionMenu from '../../components/components/action_menu/ActionMenu.jsx';

import { ReactComponent as StatusUp } from '../../components/icons/status-up.svg';
import { ReactComponent as Edit } from '../../components/icons/edit.svg';
import { ReactComponent as TaskSquare } from '../../components/icons/task-square.svg';
import { ReactComponent as Pause } from '../../components/icons/pause.svg';
import { ReactComponent as Play } from '../../components/icons/play.svg';
import { ReactComponent as Trash } from '../../components/icons/trash.svg';

import { toggleCheckedItem, toggleEditModal, toggleAddModal, setEditedEvent, setAddEventMode, setDuplicatedEventId, setModalViewActualTab, toggleNeedRefresh } from '../../store/eventsSlice';
import { setSelectedEvent } from '../../store/statsSlice.js';

const formatDate = (utcString) => {
    const date = new Date(utcString);
    return date.toLocaleString('pl-PL', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
    });
};

export const fetchUsers = async (sortBy, sortDirection, currentPage, dispatch, setMaxPages, setRows, checkedItems, keyword) => {
  try {

    const checkedSortBy = sortBy === null || sortDirection === null ? null : sortBy;
    const checkedSortDirection = sortBy === null || sortDirection === null ? null : sortDirection;
    const responseCategories = await ApiService.getEventsCategories();
    const categories = responseCategories.data;
    const response = await ApiService.getEvents(checkedSortBy, checkedSortDirection, currentPage, keyword);
    console.log('Odpowiedź z API:', response);

    dispatch(setMaxPages(response.maxPage)); // Ustawienie maksymalnej liczby stron na podstawie danych z API

    // Mapowanie danych z API do formatu zgodnego z tabelą
    const mappedRows = response.data.map((event) => [
      <input
        type="checkbox"
        checked={checkedItems && checkedItems.includes(event.id)} // Sprawdzenie, czy id znajduje się w checkedItems
        onChange={() => dispatch(toggleCheckedItem(event.id))} // Dodanie/Usunięcie id z listy
      />,
      event.id, // ID
        <div>
            <ActionMenu
                items={[
                    {
                        key: 'stats',
              label: 'Statystyki',
              icon: StatusUp,
              onClick: () => {
                dispatch(setSelectedEvent(event.id));
                window.location.href = '/statistics';
              },
            },
                    {
                        key: 'edit',
                        label: 'Edytuj',
                        icon: Edit,
                        onClick: () => {
                            dispatch(setAddEventMode(false));
                            dispatch(setEditedEvent(event.id));
                            dispatch(toggleEditModal());
                        },
                    },
            {
              key: 'duplicate',
              label: 'Duplikuj',
              icon: TaskSquare,
              onClick: () => {
                dispatch(setAddEventMode(true));
                dispatch(setModalViewActualTab('Dane podstawowe'));
                dispatch(setEditedEvent(null));
                dispatch(setDuplicatedEventId(event.id));
                dispatch(toggleAddModal());
              },
            },
            {
              key: 'deactivate',
              label: event.isActive ? 'Deaktywuj' : 'Aktywuj',
              icon: event.isActive ? Pause : Play,
              onClick: async () => {
                try {
                  await ApiService.updateEvent(event.id, { isActive: !event.isActive });
                  dispatch(toggleNeedRefresh());
                } catch (error) {
                  console.error('Błąd zmiany statusu wydarzenia:', error);
                }
              },
            },
                    {
                        key: 'delete',
                        label: 'Usuń',
                        icon: Trash,
                        danger: true,
                        onClick: () => {
                            console.log('Usuń wydarzenie:', event.id);
                        },
                    },
                ]}
            />
        </div>,
      formatDate(event.added_on_utc),
      event.name,
      <div> {event.city} - {event.place} </div>,
      formatDate(event.startDate),
      formatDate(event.endDate),
      categories.find(cat => cat.id === event.categoryId)?.name || "Brak kategorii",
      event.isActive ? "Aktywne" : "Nieaktywne",
    ]);

    setRows(mappedRows); // Ustawienie wierszy w stanie
  } catch (error) {
    console.error('Błąd podczas pobierania danych:', error);
  }
};
